// @ts-nocheck
export const MAX_TTS_PRICE_DECIMALS = 4;
export const TTS_UNIT_RUPEES = 'rupees';
export const TTS_UNIT_PAISE = 'paise';
export const TTS_PLAN_NAME_REGEX = /^[a-zA-Z0-9 ]*$/;

export function sanitizeTtsPriceInput(raw: string, allowDecimals: boolean): string | null {
  const value = String(raw).replace(/[+\-eE]/g, '');
  if (value === '') return '';
  if (allowDecimals) {
    if (!/^\d*\.?\d*$/.test(value)) return null;
    const decimalParts = value.split('.');
    if (decimalParts.length > 1 && decimalParts[1].length > MAX_TTS_PRICE_DECIMALS) {
      return null;
    }
  } else {
    if (!/^\d+$/.test(value)) return null;
  }
  if (value !== '.' && Number(value) > 1000) {
    return null;
  }
  return value;
}

export function toWholeTtsPrice(value: any) {
  if (value === '' || value === '.' || value == null) return '';
  const n = Math.trunc(Number(value));
  if (!Number.isFinite(n) || n <= 0) return '';
  return String(Math.min(n, 1000));
}

export function isPositiveTtsPrice(value: any, allowDecimals = true) {
  const num = Number(value);
  if (value === '' || value === '.' || !Number.isFinite(num) || num <= 0 || num > 1000) {
    return false;
  }
  if (!allowDecimals && (String(value).includes('.') || !Number.isInteger(num))) {
    return false;
  }
  return true;
}

const MICRO_PER_PAISE = 10000;
const PAISE_PER_RUPEE = 100;

export function toMicroPaise(value: any, unitBalance: string): number | null {
  const num = Number(value);
  if (value === null || value === undefined || value === '' || !Number.isFinite(num)) return null;
  const paise = unitBalance === TTS_UNIT_RUPEES ? num * PAISE_PER_RUPEE : num;
  return Math.round(paise * MICRO_PER_PAISE);
}

export function minimumForUnit(floorMicroPaise: number, unit: string): number {
  if (unit === TTS_UNIT_RUPEES) {
    return Math.ceil(floorMicroPaise / (PAISE_PER_RUPEE * MICRO_PER_PAISE));
  }
  return Math.ceil(floorMicroPaise) / MICRO_PER_PAISE;
}

export function getAssignedTtsPlanFloor(user: any) {
  const plan = user?.assignedCompany?.assignedTtsPlan || user?.tts_plan || null;
  if (!plan) return null;
  if (plan.is_deleted === true) return null;
  if (plan.plan_status !== undefined && Number(plan.plan_status) !== 1) return null;
  return plan;
}

export function getTtsPlanFloorError(
  floorPlan: any,
  values: { per_character: any; per_variable: any; unit_balance: string },
): string {
  if (!floorPlan) return '';
  const unitName = (u: string) => (u === TTS_UNIT_RUPEES ? 'rupees' : 'paise');

  for (const field of [
    { key: 'per_character', label: 'Per Character' },
    { key: 'per_variable', label: 'Per Variable' },
  ]) {
    const floorMicro = toMicroPaise(floorPlan[field.key], floorPlan.unit_balance);
    const candidateMicro = toMicroPaise(values[field.key], values.unit_balance);
    if (floorMicro === null || candidateMicro === null) continue;
    if (candidateMicro >= floorMicro) continue;
    return ( 
      `Minimum allowed is ` +
      `${minimumForUnit(floorMicro, values.unit_balance)} ${unitName(values.unit_balance)}.`
    );
  }
  return '';
}

export function isNewTtsPlanComplete(planName: string, unitBalance: string, perCharacter: any, perVariable: any) {
  const allowDecimals = unitBalance === TTS_UNIT_PAISE;
  return (
    !!String(planName || '').trim() &&
    TTS_PLAN_NAME_REGEX.test(String(planName || '').trim()) &&
    isPositiveTtsPrice(perCharacter, allowDecimals) &&
    isPositiveTtsPrice(perVariable, allowDecimals)
  );
}
